import { UPDATE_LANGUAGE, UPDATE_LOADING, UPDATE_MESSAGE, UPDATE_THEME } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    theme: localStorage.getItem("theme") || "light",
    loading: false,
    message: {
        type: null,
        content: null,
        data: null,
    },
    language: !!localStorage.getItem("i18nextLng")
        ? ["en", "es", "pt"].indexOf(localStorage.getItem("i18nextLng").split("-")[0]) !== -1
            ? localStorage.getItem("i18nextLng").split("-")[0]
            : "en"
        : "en",
};

const updateTheme = (state, action) => {
    return updateState(state, {
        theme: action.theme,
    });
};

const updateMessage = (state, action) => {
    return updateState(state, {
        message: action.message,
    });
};

const updateLoading = (state, action) => {
    return updateState(state, {
        loading: action.loading,
    });
};

const updateLanguage = (state, action) => {
    return updateState(state, {
        language: action.language,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_THEME:
            return updateTheme(state, action);
        case UPDATE_MESSAGE:
            return updateMessage(state, action);
        case UPDATE_LOADING:
            return updateLoading(state, action);
        case UPDATE_LANGUAGE:
            return updateLanguage(state, action);
        default:
            return state;
    }
};

export default reducer;
